<template>
  <div class="tab-details">
    <div class="top">
      <UIButton
        class="delete"
        :tiny="true"
        icon="trash"
        @click="deleteBundle"
      >{{ $t('Delete Bundle') }}</UIButton>
    </div>
    <SetupDetails :bundle="bundle" />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import SetupDetails from '../components/SetupDetails';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    SetupDetails,
    UIButton,
  },
  props: {
    bundle: {
      type: Object,
      required: true,
    },
  },
})
export default class TabDetailsRoute extends Vue {
  deleteBundle () {
    this.$store.commit('setConfirm', {
      icon: 'icon-trash',
      message: this.$t('Please contact support@springboardvr.com in order to delete your bundle from SpringboardVR.'),
      buttons: [{
        name: this.$t('OK'),
        type: 'ghost',
        action: () => { },
      }],
    });
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.top {
  width: 100%;
  margin-bottom: var(--spacingMd);
  text-align: right;
}
</style>
